import styled from '@emotion/styled'
import { Link } from 'gatsby'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'

const StyledLink = styled(Link)`
  display: block;
  margin-bottom: 30px;
  img {
    width: 300px;
    height: 132px;
  }
  p {
    text-align: center;
  }
  ${BreakPoints.large} {
    display: inline-block;
    margin: 0 10px 20px;
  }
  ${BreakPoints.medium} {
    display: block;
    text-align: center;
    margin: 0 auto 20px;
  }
`

type Props = {
  /** クラス名 */
  className?: string
  /** リンク先 */
  href: string
  /** 画像 */
  imgId: string
  /** タイトル */
  label: string
  target: string
}

/**
 * コラムサイドバー用バナーコンポーネント（製品サイト誘導）
 * @param props
 * @constructors
 */
const ColumOfficialBnr = (props: Props): JSX.Element => {
  const { className = '' } = props

  return (
    <StyledLink className={className} to={props.href} target={props.target}>
      <img
        src={`/images/column/common/${props.imgId}`}
        alt="キンクラのご紹介"
      />
      <p>{props.label}</p>
    </StyledLink>
  )
}

export default ColumOfficialBnr
